import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    component: () => import("@/view/home/homePage.vue"),
  },
  {
    path: "/infomation",
    component: () => import("@/view/home/informationPage.vue"),
  },
  {
    path: "/about",
    component: () => import("@/view/about/aboutPage.vue"),
  },
  {
    path: "/product/:id",
    component: () => import("@/view/product/productPage.vue"),
  },
  {
    path: "/task",
    component: () => import("@/view/task/taskPage.vue"),
  },
  {
    path: "/contact",
    component: () => import("@/view/contact/contactPage.vue"),
  },
  {
    path: "/dynamic/:id",
    component: () => import("@/view/dynamic/dynamicPage.vue"),
  },
   {
    path: "/note/:id",
    component: () => import("@/view/home/notePage.vue"),
  },
];

const router = new Router({
  routes,
});

export default router;
